/**
 * LoadingSpinner Component
 *
 * Full-page loading spinner with VideoGame theme
 * Used as Suspense fallback for initial app load
 */

export function LoadingSpinner() {
  return (
    <div
      className="flex items-center justify-center min-h-screen"
      style={{ backgroundColor: 'var(--theme-background)' }}
    >
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div
          className="animate-spin rounded-full h-12 w-12 border-b-2"
          style={{ borderColor: 'var(--theme-accent)' }}
        />

        {/* Loading Text */}
        <p
          className="text-sm font-mono"
          style={{ color: 'var(--theme-text-muted)' }}
        >
          Loading...
        </p>
      </div>
    </div>
  );
}

export default LoadingSpinner;
